import {gsap} from '../../_Global/js/global';

document.addEventListener('DOMContentLoaded', () => {
    const heroBanner = document.querySelector('.heroBanner');

    if (heroBanner) {
        const heroDirection = heroBanner.getAttribute('data-direction');
        const heroGraphics = document.querySelector('.hero-banner__graphics');
        const heroGraphicsWrapper = document.querySelector('.hero-banner__graphics-wrapper');
        const heroCoralLines = document.querySelector('.hero-banner__coral-lines');
        const heroAzureLines = document.querySelectorAll('.hero-banner__azure-line');
        const heroCarousel = document.querySelector('.hero-banner__carousel');
        const heroImage = document.querySelector('.hero-banner__image');
        const heroVideo = document.querySelector('.hero-banner__video');

        const heroTitle = document.querySelector('.hero-banner__title');
        const heroText = document.querySelector('.hero-banner__text');
        const heroLink = document.querySelector('.hero-banner__link');

        const metaTag = document.querySelector('meta[name="profile_pictures"]');

        const heroContactToggle = document.querySelector('.hero-banner__toggle button');
        const heroContactContent = document.querySelector('.hero-banner__contacts');

        if (heroGraphicsWrapper) {
            heroGraphicsWidth(heroGraphics, heroGraphicsWrapper);

            window.addEventListener('resize', function () {
                heroGraphicsWidth(heroGraphics, heroGraphicsWrapper);
            });

            gsap.to(heroGraphicsWrapper, {
                opacity: 1,
                duration: 0.4,
                ease: 'power1.out',
            });
        }

        if (heroContactToggle && heroContactContent) {
            const heroContactToggleText = heroContactToggle.querySelector('.button__label');

            heroContactToggle.addEventListener('click', function () {
                if (heroContactToggle.classList.contains('icon__expand--active')) {
                    heroContactToggle.classList.remove('icon__expand--active');
                    heroContactToggle.setAttribute('aria-expanded', false);
                    heroContactToggleText.textContent = 'Show contact details';

                    gsap.to(heroContactContent, {
                        opacity: 0,
                        duration: 0.2,
                        ease: 'power1.out',
                        onComplete: () => {
                            heroContactContent.style.display = 'none';
                            heroGraphics.style.display = 'flex';
                            heroGraphicsWidth(heroGraphics, heroGraphicsWrapper);

                            gsap.fromTo(
                                heroGraphics,
                                {
                                    opacity: 0,
                                },
                                {
                                    opacity: 1,
                                    duration: 0.8,
                                    ease: 'power1.out',
                                },
                            );
                        },
                    });
                } else {
                    heroContactToggle.classList.add('icon__expand--active');
                    heroContactToggle.setAttribute('aria-expanded', true);
                    heroContactToggleText.textContent = 'Hide contact details';

                    gsap.to(heroGraphics, {
                        opacity: 0,
                        duration: 0.2,
                        ease: 'power1.out',
                        onComplete: () => {
                            heroGraphics.style.display = 'none';
                            heroContactContent.style.display = 'block';

                            gsap.fromTo(
                                heroContactContent,
                                {
                                    opacity: 0,
                                },
                                {
                                    opacity: 1,
                                    duration: 0.8,
                                    ease: 'power1.out',
                                },
                            );
                        },
                    });
                }
            });
        }

        if (heroCarousel && metaTag) {
            const content = metaTag.getAttribute('content');
            let queryUrl = metaTag.getAttribute('fb');
            queryUrl = updateNumRanks(queryUrl);
            (async () => {
                queryUrl = queryUrl.replace(/&form=[^&]*/i, '') + '&form=json';
                if (queryUrl) {
                const resM = await fetchProfiles(`${queryUrl}&meta_gender=M`);
                const resF = await fetchProfiles(`${queryUrl}&meta_gender=F`);
                const sorted = [];
                const maxLength = Math.max(resF.length, resM.length);
                for (let i = 0; i < maxLength; i++) {
                  if (i < resM.length) sorted.push(resM[i]);
                  if (i < resF.length) sorted.push(resF[i]);
                }
                const imageUrls = sorted.map(p => p.imageUrl);
                imageUrls.forEach((url) => {
                    const item = document.createElement('div');
                    item.setAttribute('class', 'hero-banner__carousel-item background--gradient');
                    const itemImage = document.createElement('div');
                    itemImage.setAttribute('class', 'hero-banner__carousel-item-image');
                    itemImage.style.setProperty('background-image', 'url("' + url + '")');
                    item.appendChild(itemImage);
                    heroCarousel.appendChild(item);
                });
                const heroCarouselImages = document.querySelectorAll('.hero-banner__carousel-item');
                let heroCarouselIndex = 0;

                const timeline = gsap.timeline({
                    onStart: function () {
                        gsap.from(heroCarouselImages[heroCarouselIndex], {
                            opacity: 0,
                            delay: 0.8,
                            duration: 1.2,
                            ease: 'power1.out',
                            onStart: () => {
                                heroCarouselIndex = (heroCarouselIndex + 1) % heroCarouselImages.length;
                                gsap.to(heroCarouselImages[heroCarouselIndex], {
                                    opacity: 1,
                                    duration: 1.5,
                                    ease: 'power1.out',
                                });
                            },
                        });
                    },

                    onComplete: function () {
                        gsap.fromTo(
                            heroCoralLines,
                            {
                                '--gradient-angle': '120deg',
                            },
                            {
                                '--gradient-angle': '360deg',
                                duration: 4,
                                repeat: -1,
                                yoyo: true,
                                ease: 'power1.out',
                            },
                        );

                        function fadeImages() {
                            gsap.to(heroCarouselImages[heroCarouselIndex], {
                                opacity: 0,
                                duration: 1.2,
                                ease: 'power1.out',
                                onStart: () => {
                                    heroCarouselIndex = (heroCarouselIndex + 1) % heroCarouselImages.length;
                                    gsap.to(heroCarouselImages[heroCarouselIndex], {
                                        opacity: 1,
                                        duration: 1.5,
                                        delay: 0.8,
                                        ease: 'power1.out',
                                    });
                                },
                            });
                        }

                        if (heroDirection != 'none') {
                            if (heroImage) {
                                gsap.to(heroImage, {
                                    opacity: 0,
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: '30% top',
                                        scrub: true,
                                    },
                                });
                            }

                            if (heroVideo) {
                                gsap.to(heroVideo, {
                                    opacity: 0,
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: '30% top',
                                        scrub: true,
                                    },
                                });
                            }

                            if (heroCarousel) {
                                setInterval(fadeImages, 10000);

                                gsap.to(heroCarousel, {
                                    opacity: 0,
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: '30% top',
                                        scrub: true,
                                    },
                                });
                            }

                            gsap.to(heroCoralLines, {
                                opacity: 0,
                                scrollTrigger: {
                                    trigger: heroBanner,
                                    start: '24% top',
                                    end: 'bottom 40%',
                                    scrub: true,
                                },
                            });

                            heroAzureLines.forEach((item) => {
                                gsap.to(item, {
                                    opacity: 0,
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: 'bottom 40%',
                                        scrub: true,
                                    },
                                });
                            });
                        }

                        if (heroDirection == 'left') {
                            gsap.to(heroTitle, {
                                opacity: 0,
                                x: '100%',
                                scrollTrigger: {
                                    trigger: heroBanner,
                                    start: '20% top',
                                    end: 'bottom 30%',
                                    scrub: true,
                                },
                            });

                            if (heroText) {
                                gsap.to(heroText, {
                                    opacity: 0,
                                    x: '100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '22% top',
                                        end: 'bottom 30%',
                                        scrub: true,
                                    },
                                });
                            }

                            if (heroLink) {
                                gsap.to(heroLink, {
                                    opacity: 0,
                                    x: '100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: 'bottom 30%',
                                        scrub: true,
                                    },
                                });
                            }

                            gsap.to(heroCoralLines, {
                                left: '-120%',
                                scrollTrigger: {
                                    trigger: heroBanner,
                                    start: '24% top',
                                    end: '50% top',
                                    scrub: true,
                                },
                            });

                            heroAzureLines.forEach((item, index) => {
                                gsap.to(item, {
                                    right: '-40%',
                                    x: '100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: 24 - index * 2 + '% top',
                                        end: 'bottom 20%',
                                        scrub: true,
                                    },
                                });
                            });
                        } else if (heroDirection != 'none') {
                            gsap.to(heroTitle, {
                                opacity: 0,
                                x: '-100%',
                                scrollTrigger: {
                                    trigger: heroBanner,
                                    start: '20% top',
                                    end: 'bottom 30%',
                                    scrub: true,
                                },
                            });

                            if (heroText) {
                                gsap.to(heroText, {
                                    opacity: 0,
                                    x: '-100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '22% top',
                                        end: 'bottom 30%',
                                        scrub: true,
                                    },
                                });
                            }

                            if (heroLink) {
                                gsap.to(heroLink, {
                                    opacity: 0,
                                    x: '-100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: '24% top',
                                        end: 'bottom 30%',
                                        scrub: true,
                                    },
                                });
                            }

                            gsap.to(heroCoralLines, {
                                right: '-120%',
                                scrollTrigger: {
                                    trigger: heroBanner,
                                    start: '24% top',
                                    end: '50% top',
                                    scrub: true,
                                },
                            });

                            heroAzureLines.forEach((item, index) => {
                                gsap.to(item, {
                                    left: '-40%',
                                    x: '-100%',
                                    scrollTrigger: {
                                        trigger: heroBanner,
                                        start: 24 + index * 2 + '% top',
                                        end: 'bottom 20%',
                                        scrub: true,
                                    },
                                });
                            });
                        }
                    },
                });

                timeline.addLabel('lines');

                timeline
                    .to(
                        heroCoralLines,
                        {
                            opacity: 1,
                            duration: 0.8,
                            ease: 'power1.out',
                        },
                        'lines',
                    )
                    .to(
                        heroCoralLines,
                        {
                            y: 0,
                            duration: 2,
                            ease: 'power1.out',
                        },
                        'lines',
                    );

                heroAzureLines.forEach((item, index) => {
                    timeline.to(
                        item,
                        {
                            duration: 0.7,
                            opacity: 1,
                            y: 0,
                            ease: 'power1.out',
                        },
                        'lines+=' + index * 0.05,
                    );
                });
                } // End queryUrl
            })();
        }
    }

    async function fetchProfiles(url) {
      try {
        const res = await fetch(url);
        const json = await res.json();
        return json;
      } catch (err) {
        console.error("Error:", err);
      }
    }

    function updateNumRanks(url, newValue = 5) {
      const urlObj = new URL(url);
      urlObj.searchParams.set('num_ranks', newValue);
      return urlObj.toString();
    }

    function heroGraphicsWidth(heroGraphics, heroGraphicsWrapper) {
        const computedStyle = window.getComputedStyle(heroGraphicsWrapper);
        const heroGraphicsRect = heroGraphics.getBoundingClientRect();
        const heroGraphicsWidth = heroGraphicsRect.width;
        const heroGraphicsHeight = heroGraphicsRect.height;

        const maxWidth = heroGraphicsHeight * 1.28;

        if (maxWidth < heroGraphicsWidth && computedStyle.position == 'relative') {
            heroGraphicsWrapper.style.width = `${maxWidth}px`;
        } else {
            heroGraphicsWrapper.style.width = '100%';
        }
    }
});
